import React, { memo, useEffect, useState } from 'react';
import { sample } from 'lodash';
import { ShimmerThinkingIndicator } from '../../journeys/PromptResponse';
import { ThinkingContainer } from '../KaizenChatSession.styles';

const phrases = [
  'Generating response',
  'Composing reply',
  'Processing request',
  'Crafting a response',
  'Working on it'
];

const molassesPhrases = ['still thinking', 'almost there', 'deep in thought', 'bear with me'];

const WAIT_MS = 10000;

// Memoized component to prevent unnecessary re-renders
const ThinkingIndicator = memo(({ text }) => {
  const [slowSuffix, setSlowSuffix] = useState('');

  // Reset suffix when text changes
  useEffect(() => {
    setSlowSuffix('');
    let mounted = true;
    const timer = setTimeout(() => {
      if (mounted) {
        setSlowSuffix(` - ${sample(molassesPhrases)}`);
      }
    }, WAIT_MS);

    return () => {
      mounted = false;
      clearTimeout(timer);
    };
  }, [text]);

  return (
    <ThinkingContainer>
      <ShimmerThinkingIndicator>
        {text || sample(phrases)}
        {slowSuffix}
      </ShimmerThinkingIndicator>
    </ThinkingContainer>
  );
});

ThinkingIndicator.displayName = 'ThinkingIndicator';

export default ThinkingIndicator;
